import React from 'react'
import { Link } from 'react-router-dom'
import { handleImageError } from '../../utils/imageUtils'
import USER_TYPE from '../../constants/userType'
import DisplayShopName from '../common/DisplayShopName'
import ShopLocation from '../common/ShopLocation'

export const RetailerCard = ({ retailer }) => {
  const retailerName = retailer.shopName
  const imageUrl = retailer.shopPicture

  const retailerProductLink =
    retailer?.userType === USER_TYPE.wholeseller
      ? `/wholesellers/${retailer.shopSlug}/products`
      : `/retailers/${retailer.shopSlug}/products`

  return (
    <div className="border border-secondary-200/30 rounded-md overflow-hidden bg-background flex p-3 space-x-3 items-start">
      <div className="flex-shrink-0 w-16  md:w-20  lg:w-24 aspect-square">
        <Link to={retailerProductLink}>
          <img
            src={imageUrl}
            alt={retailerName}
            className="w-full h-full object-contain  rounded-md bg-neutral-200-100"
            onError={handleImageError}
          />
        </Link>
      </div>

      <div className="flex-grow min-w-0">
        <Link to={retailerProductLink} className="block group">
          <h3 className="text-base font-semibold text-gray-800 truncate group-hover:text-blue-600">
            <DisplayShopName
              shop={{
                name: retailerName,
                isPremium: retailer.isPremium,
                isVerified: retailer.isApproved,
              }}
            />
          </h3>
        </Link>
        <ShopLocation
          shop={{
            shopNumber: retailer.shopNumber,
            floor: retailer.floor,
            buildingName: retailer.buildingName,
          }}
          showIcons={false}
          className="text-blue-600 mt-1"
        />
      </div>
    </div>
  )
}

export default RetailerCard
